<template>
    <transition name="fade" mode="out-in">
        <div v-show="show" class="notification">
            <img :src="loadSuccessIcon" />
            <p>{{ content }}</p>
        </div>
    </transition>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        props: {
            content: { type: String, required: true },
        },

        data() {
            return {
                show: false,
            }
        },

        computed: {
            loadSuccessIcon: function () {
                return require('../../../src/images/sucess-icon.svg').default
            },
        },

        methods: {
            showNotification: function () {
                this.show = true
            },

            hideNotification: function () {
                this.show = false
            },
        },

        watch: {
            show: function () {
                this.debouncedHideNotification()
            },
        },

        created: function () {
            this.debouncedHideNotification = debounce(this.hideNotification, 2000)
        },
    }
</script>
